import { OptionHeader, Paragraph } from '@fjordline/styles-v3'
import React, { useState } from 'react'
import useFetchPayableWithClubPointsFromSanity from '../sanity/cruise/useFetchPayableWithClubPointsJourneys'
import { useTranslation } from 'react-i18next'
import { imageUrlFor } from '../sanity/imageUrlBuilder'
import { ENVIRONMENT } from '../config'
import { useGetCustomerQuery } from '../graphql'
import { GetSanityImageUrl } from '../utils/imageUtils'
import { OptionHeaderWrapper } from './PayWithClubPoints.styled'
import Page from '../components/Page'

// TODO: fetch this from Sanity homeport dataset
const localeOfferPath = {
  nb: 'tilbud-batreiser',
  da: 'tilbud-overfarter',
  de: 'angebote-fahrpassage',
  en: 'offers-boat-trips',
}

export function PayWithClubPoints() {
  const { t } = useTranslation()
  const { data } = useGetCustomerQuery()
  const clubPoints = data?.customer.loyaltyPoints?.redeemablePoints
  const [chooseOption, setChooseOption] = useState<number>(1)
  const { payableWithClubPoints } = useFetchPayableWithClubPointsFromSanity({
    showFCPoints: chooseOption === 1 ? true : false,
  })

  return (
    <Page>
      <h1>Fjord Club {t('bookingListStatus.journeys')}</h1>
      <h3 className="mb-[var(--spacing-3XL)]">
        {clubPoints ? t('payWithFjordClubPoints.ingress', { points: clubPoints }) : t('payWithFjordClubPoints.ingressNoPoints')}
      </h3>
      <OptionHeaderWrapper className="mb-[var(--spacing-L)]">
        <OptionHeader
          options={[
            {
              id: 1,
              isSelected: chooseOption === 1 ? true : false,
              title: t('payWithFjordClubPoints.headline'),
              onClick: () => {
                setChooseOption(1)
              },
            },
            {
              id: 2,
              isSelected: chooseOption === 2 ? true : false,
              title: 'Fjord Club ' + ' ' + t('bookingListStatus.journeys'),
              onClick: () => {
                setChooseOption(2)
              },
            },
          ]}
        />
      </OptionHeaderWrapper>
      <div className="w-full grid grid-cols-[repeat(auto-fit,_minmax(300px,_1fr))] gap-[var(--spacing-L)] mb-[var(--spacing-3XL)]">
        {payableWithClubPoints.map((journey, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <JourneyCard key={index} journey={journey} />
        ))}
      </div>
    </Page>
  )
}

type JourneyCardProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  journey: any
}
const JourneyCard = ({ journey }: JourneyCardProps) => {
  console.log(journey)
  const { i18n, t } = useTranslation()
  const headerImage =
  GetSanityImageUrl(
    imageUrlFor(journey.content?.images?.[0]?.asset?._ref)?.url() ??
    'https://cdn.sanity.io/images/90kslno9/homeport/6ed26d17ee7d969dbd8cedbb1e35cad5ccf61bb6-1920x1230.webp'
  )

  const mainPage = ENVIRONMENT === 'PROD' ? 'https://www.fjordline.com' : 'https://homeport-test.fjordline.com'

  const readMoreUrl = `${mainPage}/${i18n.language}/${localeOfferPath?.[i18n.language]}/${journey.slug.current}`

  const priceNordic = i18n.language === 'nb' || i18n.language === 'da' ? ',-' : ''
  const priceEU = i18n.language === 'en' || i18n.language === 'de' ? '€' : ''

  return (
    <div className="border border-[#D7D8E0] rounded-xl h-auto bg-white">
      <div className="relative overflow-hidden rounded-t-lg">
        {journey?.packageRules.productCode.payableWithClubPoints === true && (
            <div
              className="
                absolute left-[-100px] top-[-100px] w-[200px] h-[200px] bg-fl-red opacity-90 text-white text-xs 
                flex flex-col items-center justify-center p-2 shadow-[0_0_10px_0_rgba(95,95,95,0.5)] 
                transform rotate-[-45deg] z-10 text-center
              "
            >
              <span
                className="
                  absolute bottom-2 left-[30px] w-[calc(100%-60px)] text-center 
                  font-medium leading-[1.2] text-white
                "
              >
                {t('payWithFjordClubPoints.navBar')}
              </span>
            </div>
        )}
        <img
          onClick={() => {
            window.open(readMoreUrl, '_blank')
          }}
          src={headerImage}
          alt="journey"
          className="cursor-pointer w-full h-48 object-cover rounded-t-lg"
        />
      </div>
      <div className="flex flex-col flex-1 max-h-[300px] h-full min-h-[300px] p-[22px_25px_34px] md:h-auto md:p-[12px_15px_24px]">
        <h3>{journey.name}</h3>
        <Paragraph>{journey.content?.summary}</Paragraph>
      </div>
      <div className="flex items-center bg-fl-red border-t border-[#f7f7f7] text-white justify-between min-h-[85px] px-[14px] rounded-b-[8px] mt-[1rem]">
        <span className="text-white block font-semibold">
          <small className="text-white inline-block text-xs font-normal mr-[3px]">{t('payWithFjordClubPoints.from')}</small>
          <span className="inline-block text-[30px] text-white leading-none font-semibold">
            {priceEU}
            {journey.priceInfo.price} {priceNordic}
          </span>
          <span className="border-t-0 text-white block text-xs font-normal mb-0 pt-auto">{journey.priceDescription}</span>
        </span>
        <a href={readMoreUrl} className="bg-white rounded-[10px] text-[#222] text-sm font-medium p-[10px_20px_9px] no-underline transition-colors duration-200 ease-out cursor-pointer hover:bg-[#e0e0e0] hover:text-[#222] hover:no-underline">
          {t('component.extras.common.readMore')}
        </a>
      </div>
    </div>
  )
}
